/** ч.1313: відповідальний за запис — зіставлення користувачів 1С і передача іншому. */
import { api } from './client';

export interface OwnerMember {
  user_id: string;
  full_name: string;
  email: string;
  tenant_role: string;
}

export interface RecordOwnerInfo {
  user_id: string | null;
  full_name: string | null;
  email: string | null;
  /** Запис перенесено з 1С (відповідальний — із зіставлення користувачів 1С). */
  imported: boolean;
  /** Власник / адміністратор акаунта — може передати. */
  can_transfer: boolean;
  /** Кому можна передати: учасники з доступом до організації запису. */
  candidates: OwnerMember[];
}

export interface User1C {
  external_id: string;
  code: string | null;
  name: string;
  mapped_user_id: string | null;
  suggested_user_id: string | null;
  documents: number;
  contractors: number;
}

export interface TransferAllResult {
  dry_run: boolean;
  kinds: { code: string; label: string; count: number }[];
  total: number;
  /** Документи організацій, куди новий відповідальний доступу не має, — лишились. */
  kept: number;
}

export const recordOwners = {
  owner: (documentType: string, documentId: string) =>
    api.get<RecordOwnerInfo>('/record-owners/owner', {
      params: { document_type: documentType, document_id: documentId },
    }).then((r) => r.data),
  transfer: (documentType: string, ids: string[], toUserId: string) =>
    api.post<{ transferred: number }>('/record-owners/transfer', {
      document_type: documentType, ids, to_user_id: toUserId,
    }).then((r) => r.data),
  transferAll: (fromUserId: string, toUserId: string, dryRun: boolean) =>
    api.post<TransferAllResult>('/record-owners/transfer-all', {
      from_user_id: fromUserId, to_user_id: toUserId, dry_run: dryRun,
    }).then((r) => r.data),
  users1c: () =>
    api.get<{ users: User1C[]; members: OwnerMember[] }>('/record-owners/users-1c').then((r) => r.data),
  map1c: (externalId: string, userId: string | null) =>
    api.post<{ updated: number }>('/record-owners/users-1c/map', {
      external_id: externalId, user_id: userId,
    }).then((r) => r.data),
};
